import { Menu, MenuItem, MenuList, MenuPopover, MenuTrigger, makeStyles, tokens } from "@fluentui/react-components";
import { MoreHorizontal16Regular } from "@fluentui/react-icons";
import { useDialogLayer } from "@/components/ui/dialog-layer";

export type MockCase = { id: string; label: string };

const useStyles = makeStyles({
  btn: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: "24px",
    height: "24px",
    padding: 0,
    border: "none",
    borderRadius: tokens.borderRadiusMedium,
    backgroundColor: "transparent",
    color: tokens.colorNeutralForeground3,
    cursor: "pointer",
    ":hover": {
      backgroundColor: tokens.colorNeutralBackground1Hover,
      color: tokens.colorNeutralForeground1,
    },
    ":focus-visible": {
      outline: `2px solid ${tokens.colorStrokeFocus2}`,
      outlineOffset: "1px",
    },
  },
  // 모달은 body의 클릭을 막는다. 레이어 밖 포털은 보이기만 하고 눌리지 않는다.
  popover: {
    zIndex: 100,
    pointerEvents: "auto",
  },
});

/** 제목 바로 오른쪽에 두는 목업 사례. 고르면 그 화면 상태로 바뀐다. */
export function MockCaseMenu({ cases, onPick }: { cases: MockCase[]; onPick: (id: string) => void }) {
  const styles = useStyles();
  const layer = useDialogLayer();
  return (
    <Menu mountNode={layer} positioning={{ strategy: "fixed", position: "below", align: "end" }}>
      <MenuTrigger disableButtonEnhancement>
        <button type="button" className={styles.btn} aria-label="목업 사례" title="목업 사례">
          <MoreHorizontal16Regular />
        </button>
      </MenuTrigger>
      <MenuPopover className={styles.popover}>
        <MenuList>
          {cases.map((item) => (
            <MenuItem key={item.id} onClick={() => onPick(item.id)}>
              {item.label}
            </MenuItem>
          ))}
        </MenuList>
      </MenuPopover>
    </Menu>
  );
}
